const { JsSIP } = window;
let myCandidateTimeout = null
class UserAgent {
  socket = null;
  userAgent = null;
  status = "testStart";
  status2 = "";
  currentSession = null;
  static confirmed = false;

  static calling = false;

  static ended;
  constructor(options) {
    this.wssUrl = options.wssUrl;
    this.sipUrl = options.sipUrl;
    this.userNumber = options.userNumber;
    this.deviceNumber = options.deviceNumber;
    this.password = options.password;
    this.gotRemoteMedia = options.gotRemoteMedia;
    this.init();
    this.startTalk = options.startTalk;
    this.registered = options.registered;
    UserAgent.ended = options.ended;
  }

  init() {
    if (!this.socket) {
      this.socket = new JsSIP.WebSocketInterface(this.wssUrl);
      this.socket.via_transport = "ws";
      console.log(this.socket);
    }
    console.log(`sip:${this.userNumber}@${this.sipUrl}`);
    var configuration = {
      sockets: [this.socket],
      outbound_proxy_set: this.wssUrl,
      uri: `sip:${this.userNumber}@${this.sipUrl}`, //与用户代理关联的SIP URI（字符串）。这是您的提供商提供给您的SIP地址
      password: this.password, //SIP身份验证密码
      register: true, //指示启动时JsSIP用户代理是否应自动注册
      session_timers: false, //启用会话计时器（根据RFC 4028）
      rtcConfiguration: {
        iceServers: [
          {
            urls: ["stun:121.196.247.40:3478"],
          },
        ],
      }
    };
    this.userAgent = new JsSIP.UA(configuration);
    this.userAgent.on("connecting", () => {
      console.log("sip正在连接");
    });
    this.userAgent.on("connected", () => {
      console.log("sip连接成功");
    });
    //成功注册成功,data:Response JsSIP.IncomingResponse收到的SIP 2XX响应的实例
    this.userAgent.on("registered", (data) => {
      console.log("1111111registered", this);
      console.log(Date.now());
      this.status = "registered";
      this.registered();
      console.info(
        "registered: ",
        data.response.status_code,
        ",",
        data.response.reason_phrase
      );
    });
    //由于注册失败而被解雇,data:Response JsSIP.IncomingResponse接收到的SIP否定响应的实例，如果失败是由这样的响应的接收产生的，否则为空
    this.userAgent.on("registrationFailed", (data) => {
      console.log("registrationFailed, ", data);
      this.status = "registrationFailed";
      //console.warn("registrationFailed, ", data.response.status_code, ",", data.response.reason_phrase, " cause - ", data.cause);
    });

    //1.在注册到期之前发射几秒钟。如果应用程序没有为这个事件设置任何监听器，JsSIP将像往常一样重新注册。
    // 2.如果应用程序订阅了这个事件，它负责ua.register()在registrationExpiring事件中调用（否则注册将过期）。
    // 3.此事件使应用程序有机会在重新注册之前执行异步操作。对于那些在REGISTER请求中的自定义SIP头中使用外部获得的“令牌”的环境很有用。
    this.userAgent.on("registrationExpiring", () => {
      this.status = "registrationExpiring";
      console.warn("registrationExpiring");
    });
    this.userAgent.on("newRTCSession", (data) => {
      this.status2 = "newRTCSession";
      console.info("onNewRTCSession: ", data);
      this.currentSession = data.session;
      if (data.originator == "remote") {
        //incoming call
        console.info("incomingSession, answer the call");
        //回答传入会话。此方法仅适用于传入会话。
        this.currentSession.answer({
          mediaConstraints: { audio: true, video: false },
          pcConfig: {
            iceServers: [
              {
                urls: "stun:121.196.247.40:3478",
              }
            ],
          }
        });
      }
      //接受呼叫时激发
      this.currentSession.on("accepted", function (data) {
        console.info("onAccepted - ", data);
      });
      //确认呼叫后激发
      this.currentSession.on("confirmed", (data) => {
        console.info("onConfirmed - ", data);
        const stream = new MediaStream();
        const receivers = this.currentSession.connection?.getReceivers();
        if (receivers) {
          receivers.forEach((receiver) => stream.addTrack(receiver.track));
          this.gotRemoteMedia(stream);
          setTimeout(() => {
            UserAgent.confirmed = true;
            this.startTalk();
          }, 1000);
        }
        // else {
        //   UserAgent.ended && UserAgent.ended();
        // }
      });
      //在将远程SDP传递到RTC引擎之前以及在发送本地SDP之前激发。此事件提供了修改传入和传出SDP的机制。
      this.currentSession.on("sdp", function (data) {
        console.info("onSDP, type - ", data.type, " sdp - ", data.sdp);
      });
      //接收或生成对邀请请求的1XX SIP类响应（>100）时激发。该事件在SDP处理之前触发（如果存在），以便在需要时对其进行微调，甚至通过删除数据对象中响应参数的主体来删除它
      this.currentSession.on("progress", function (data) {
        console.info("onProgress - ", data);
      });
      //创建基础RTCPeerConnection后激发。应用程序有机会通过在peerconnection上添加RTCDataChannel或设置相应的事件侦听器来更改peerconnection。
      this.currentSession.on("peerconnection", function (data) {
        console.info("onPeerconnection - ", data.peerconnection);
      });

      this.currentSession.on('icecandidate', (candidate) => {
        console.log('getting a candidate' + candidate);
        if (myCandidateTimeout != null) {
          clearTimeout(myCandidateTimeout);
        }
        // srflx:stun服务发现的候选者,relay:turn服务发现的候选者
        if (
          candidate.candidate.type === "srflx" ||
          candidate.candidate.type === "relay"
        ) {
          candidate.ready();
        }
        myCandidateTimeout = setTimeout(candidate.ready, 1000);
      })

    });
    this.userAgent.start();
  }
  testCall() {
    if (UserAgent.calling) {
      return;
    }
    // 'stun:stun1.l.google.com:19302'
    var options = {
      eventHandlers: this.eventHandlers,
      mediaConstraints: { audio: true, video: false },
      pcConfig: {
        iceServers: [
          {
            urls: "stun:121.196.247.40:3478",
          }
        ],
      }
    };
    this.userAgent.call(`sip:${this.deviceNumber}@${this.sipUrl}`, options);
    UserAgent.calling = true;
  }
  eventHandlers = {
    progress: function (e) {
      console.log("call is in progress", e);
    },
    failed: function (e) {
      console.log("call failed: ", e);
      UserAgent.calling = false;
      UserAgent.ended && UserAgent.ended();
    },
    ended: function (e) {
      console.log("call ended : ", e);
      UserAgent.confirmed = false;
      UserAgent.calling = false;
      UserAgent.ended && UserAgent.ended();
    },
    confirmed: function (e) {
      console.log("call confirmed", e);
    },
  };

  destroy() {
    this.currentSession = null;
    this.socket = null;
  }
}

export default UserAgent;
